import { useUserContext } from '../contexts/user-context'
import { useNavigate } from 'react-router-dom'
import { AUTH_KEY, AUTH_TYPE_KEY } from '../constants/localStorageKeys'
import { IcaButton } from './IcaElements/IcaButton'
import { removeFromStorage } from '../utils/storageUtils'

const Logout = () => {
  const navigate = useNavigate()
  const { userReducer } = useUserContext()
  const logoutUser = () => {
    removeFromStorage(AUTH_KEY)
    removeFromStorage(AUTH_TYPE_KEY)
    userReducer.resetUser()
    navigate('/login')
  }

  return (<IcaButton onClick={logoutUser} text='Logga ut' variation='secondary' small></IcaButton>)
}

export default Logout